"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FloodgateEngine = void 0;
var IFloodgateStorageProvider = require("./Api/IFloodgateStorageProvider");
var CampaignDefinitionProvider_1 = require("./Campaign/CampaignDefinitionProvider");
var CampaignManager_1 = require("./Campaign/CampaignManager");
var CampaignStateProvider_1 = require("./Campaign/CampaignStateProvider");
var Constants_1 = require("./Constants");
var FloodgateSettings_1 = require("./FloodgateSettings");
var GovernedChannel_1 = require("./GovernedChannel");
var GovernedChannelStateProvider_1 = require("./GovernedChannelStateProvider");
var Governor_1 = require("./Governor");
var SurveyActivityListener = require("./SurveyActivityListener");
var SurveyStatCollectionActivation_1 = require("./SurveyStatCollectionActivation");
var SurveyStatCollectionEventActivity_1 = require("./SurveyStatCollectionEventActivity");
var FileType = IFloodgateStorageProvider.FileType;
var ActivityTrackingContract_1 = require("./ActivityTrackingContract");
var GovernanceUtils_1 = require("./GovernanceUtils");
var Utils_1 = require("./Utils");
// Telemetry logger with no-op logger
var DefaultFloodgateTelemetryLogger = /** @class */function () {
  function DefaultFloodgateTelemetryLogger() {}
  // @Override
  DefaultFloodgateTelemetryLogger.prototype.log_TriggerMet = function (campaignId, surveyId, surveyType, surveyActivityInfo, additionalSurveyInfo) {};
  // @Override
  DefaultFloodgateTelemetryLogger.prototype.log_UserSelected = function (campaignId, surveyId, surveyType, additionalSurveyInfo) {};
  // @Override
  DefaultFloodgateTelemetryLogger.prototype.log_CampaignLoad_Failed = function (errorMessage) {};
  // @Override
  DefaultFloodgateTelemetryLogger.prototype.log_Error = function (eventId, errorMessage) {};
  // @Override
  DefaultFloodgateTelemetryLogger.prototype.log_Event = function (eventId, properties) {};
  // @Override
  DefaultFloodgateTelemetryLogger.prototype.log_LocalError = function (message) {
    var data = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      data[_i - 1] = arguments[_i];
    }
  };
  return DefaultFloodgateTelemetryLogger;
}();
var defaultSurveyActivityListener = {
  run: function (survey) {},
  shouldAcceptActivity: function (activityName) {
    return true;
  }
};
/**
 * Floodgate Engine class.  The main wiring hub and the brains responsible for
 * linking together the survey definitions, governance, activity tracking, and
 * survey launchers.  Only one-instance-at-a-time of these should be created
 * per app session.
 */
var FloodgateEngine = /** @class */function () {
  function FloodgateEngine(surveyClient, activityListener, launcherFactory, onSurveyActivatedCallback, storage, governor, surveyActivationStatsProvider, transporterFactory, governanceServiceClient) {
    this.initializationStatus = 0 /* None */;
    this.candidateSurveys = {};
    this.launchedSurveys = {};
    this.launchedLaunchers = [];
    this.surveyEventSent = [];
    this.staleTriggeredSurveysQueue = [];
    if (!surveyClient) {
      throw new Error("surveyClient must not be null");
    }
    if (!activityListener) {
      throw new Error("activityListener must not be null");
    }
    if (!launcherFactory) {
      throw new Error("launcherFactory must not be null");
    }
    if (!onSurveyActivatedCallback) {
      throw new Error("onSurveyActivatedCallback must not be null");
    }
    if (!storage) {
      throw new Error("storage must not be null");
    }
    if (!governor) {
      throw new Error("governor must not be null");
    }
    if (!transporterFactory) {
      throw new Error("transporterFactory must not be null");
    }
    this.surveyClient = surveyClient;
    this.activityListener = activityListener;
    this.launcherFactory = launcherFactory;
    this.onSurveyActivatedCallback = onSurveyActivatedCallback;
    this.storage = storage;
    this.governor = governor;
    this.surveyActivationStatsProvider = surveyActivationStatsProvider;
    this.governanceServiceClient = governanceServiceClient;
    FloodgateEngine.transporterFactory = transporterFactory;
    this.loggedFirstStart = false;
    // Initialize our list to a valid, empty collection
    this.setPendingSurveys(null);
    // If the listener was pre-configured with survey for some reason, clear it now
    this.activityListener.clearSurveys();
    // Link ourselves with the listener
    var thisObj = this; // Save current object in a variable to allow access from callback.
    this.activityListener.setCallback({
      run: function (surveyId) {
        thisObj.onSurveyActivated(surveyId);
      },
      shouldAcceptActivity: function (activityName) {
        return thisObj.shouldAcceptActivity(activityName);
      }
    });
  }
  FloodgateEngine.setTelemetryLogger = function (telemetryLogger) {
    if (!telemetryLogger) {
      throw new Error("telemetryLogger must not be null");
    }
    FloodgateEngine.telemetryLogger = telemetryLogger;
  };
  FloodgateEngine.getTelemetryLogger = function () {
    return FloodgateEngine.telemetryLogger;
  };
  FloodgateEngine.getTransportFactory = function () {
    return FloodgateEngine.transporterFactory;
  };
  FloodgateEngine.make = function (buildVersion, launcherFactory, onSurveyActivatedCallback, fileBasedStorageProvider, hostBasedStorageProvider, stringProvider, environmentProvider, transporterFactory, campaignDefinitionProviders, userFactsProvider, governanceServiceClient) {
    try {
      var governedChannelStateProvider = GovernedChannelStateProvider_1.GovernedChannelStateProviderFactory.make(fileBasedStorageProvider, hostBasedStorageProvider);
      var surveyActivationStatsProvider = SurveyStatCollectionActivation_1.SurveyActivationStatsProviderFactory.make(fileBasedStorageProvider, hostBasedStorageProvider);
      var campaignStateProvider = CampaignStateProvider_1.CampaignStateProviderFactory.make(fileBasedStorageProvider, hostBasedStorageProvider);
      campaignDefinitionProviders.push(new CampaignDefinitionProvider_1.FileSystemCampaignDefinitionProvider(fileBasedStorageProvider));
      return new FloodgateEngine(new CampaignManager_1.CampaignManager(campaignStateProvider, campaignDefinitionProviders, stringProvider, environmentProvider, buildVersion, new Date(), userFactsProvider), new SurveyActivityListener(defaultSurveyActivityListener, this.getTelemetryLogger), launcherFactory, onSurveyActivatedCallback, fileBasedStorageProvider, new Governor_1.Governor(governedChannelStateProvider), surveyActivationStatsProvider, transporterFactory, governanceServiceClient);
    } catch (e) {
      this.telemetryLogger.log_Event(Constants_1.TelemetryEvent.FloodgateEngine.Make.Failed, {
        ErrorMessage: e && e.toString(),
        ErrorDetails: e && e.stack
      });
    }
  };
  /**
   * Save all internal stats and floodgateSettings (merging with existing file contents), without stopping the engine.
   */
  FloodgateEngine.prototype.mergeAndSave = function () {
    this.saveSettings();
    this.saveSurveyActivationHistory();
    this.saveSurveyEventActivityHistory();
    // Inform surveyClient to save its state
    this.surveyClient.saveCurrentState();
    // Save governed channel states
    this.governor.saveChannelStates();
  };
  /**
   * Start the engine.  Checks feature enable state, causes survey definitions to be read, and tracked activities to be set on the listener.
   */
  FloodgateEngine.prototype.start = function () {
    if (this.initializationStatus === 2 /* Initializing */ || this.initializationStatus === 3 /* Started */) {
      return;
    }
    try {
      this.setInitializationStatus(2 /* Initializing */);
      this.loadSettingsAndPriorEventCounts();
      var channelTypes = this.getAvailableChannelTypes();
      this.surveyClient.refreshSurveyDefinitions(channelTypes);
      this.setPendingSurveysAndStartFloodgate();
      this.setInitializationStatus(3 /* Started */);
    } catch (e) {
      this.setInitializationStatus(1 /* Error */);
      FloodgateEngine.getTelemetryLogger().log_Event(Constants_1.TelemetryEvent.FloodgateEngine.Start.Failed, {
        ErrorMessage: e && e.toString(),
        ErrorDetails: e && e.stack
      });
    }
  };
  /**
   * Start the engine.  Checks feature enable state, causes survey definitions to be read, and tracked activities to be set on the listener.
   */
  FloodgateEngine.prototype.startAsync = function () {
    if (this.initializationStatus === 2 /* Initializing */ || this.initializationStatus === 3 /* Started */) {
      return Promise.resolve();
    }
    try {
      this.setInitializationStatus(2 /* Initializing */);
      this.loadSettingsAndPriorEventCounts();
      var channelTypes_1 = this.getAvailableChannelTypes();
      var thisFloodgateEngine_1 = this;
      return new Promise(function (resolve, reject) {
        thisFloodgateEngine_1.surveyClient.refreshSurveyDefinitionsAsync(channelTypes_1).then(function onFulfilled() {
          // Handle any stop() calls that happened while initializing
          if (thisFloodgateEngine_1.initializationStatus === 4 /* Stopped */) {
            thisFloodgateEngine_1.setInitializationStatus(3 /* Started */);
            thisFloodgateEngine_1.stop();
            FloodgateEngine.getTelemetryLogger().log_Event(Constants_1.TelemetryEvent.FloodgateEngine.StartAsync.Stopped, {
              ErrorMessage: "Stopped because of a pending stop() call"
            });
          } else {
            thisFloodgateEngine_1.setPendingSurveysAndStartFloodgate();
          }
          resolve();
        }).catch(function OnRejected(error) {
          thisFloodgateEngine_1.setInitializationStatus(1 /* Error */);
          FloodgateEngine.getTelemetryLogger().log_Event(Constants_1.TelemetryEvent.FloodgateEngine.StartAsync.Failed, {
            ErrorMessage: "Survey refresh error " + (error && error.message)
          });
          reject(error);
        });
      });
    } catch (e) {
      this.setInitializationStatus(1 /* Error */);
      FloodgateEngine.getTelemetryLogger().log_Event(Constants_1.TelemetryEvent.FloodgateEngine.StartAsync.Failed, {
        ErrorMessage: e && e.toString(),
        ErrorDetails: e && e.stack
      });
      return Promise.resolve();
    }
  };
  /**
   * Stop the engine.  Causes tracked activities to be cleared and any in-progress counters not otherwise saved to be thrown out.
   */
  FloodgateEngine.prototype.stop = function () {
    if (this.initializationStatus === 3 /* Started */) {
      this.mergeAndSave();
      // Clear our Survey list, and push that through to the listener
      this.setPendingSurveys(null);
      this.updateActivityListenerWithCurrentSurveyDefinitions();
    }
    this.setInitializationStatus(4 /* Stopped */);
  };
  /**
   * Gets the IActivityListener logging interface for callers that want to log directly rather than through telemetry
   */
  FloodgateEngine.prototype.getActivityListener = function () {
    return this.activityListener;
  };
  FloodgateEngine.prototype.setInitializationStatus = function (status) {
    this.initializationStatus = status;
  };
  FloodgateEngine.prototype.saveSettings = function () {
    this.storage.fileLock(FileType.FloodgateSettings);
    try {
      this.writeString(FileType.FloodgateSettings, FloodgateSettings_1.FloodgateSettings.toJson(this.floodgateSettings));
    } finally {
      this.storage.fileUnlock(FileType.FloodgateSettings);
    }
  };
  FloodgateEngine.prototype.loadSettingsAndPriorEventCounts = function () {
    try {
      // Load up the prior survey history and prior event counts
      this.previousSurveyActivationStats = this.surveyActivationStatsProvider.load();
      // clear previous session launch counts
      var previousStatsDictionary = this.previousSurveyActivationStats.getStats();
      for (var key in previousStatsDictionary) {
        if (previousStatsDictionary.hasOwnProperty(key)) {
          var previousStats = previousStatsDictionary[key];
          previousStats.SurveyLaunchCountPerSession = 0;
        }
      }
      this.previousSurveyEventActivityStats = SurveyStatCollectionEventActivity_1.SurveyStatCollectionEventActivity.fromJson(this.readString(FileType.SurveyEventActivityStats));
      // get the list of survey Id - all the survey should have event sent already
      var stats = this.previousSurveyEventActivityStats.getStats();
      for (var key in stats) {
        if (stats.hasOwnProperty(key)) {
          this.surveyEventSent.push(key);
        }
      }
      // Load up the general floodgateSettings
      this.floodgateSettings = FloodgateSettings_1.FloodgateSettings.fromJson(this.readString(FileType.FloodgateSettings));
    } catch (e) {
      FloodgateEngine.getTelemetryLogger().log_Event(Constants_1.TelemetryEvent.FloodgateEngine.Common.Error, {
        ErrorMessage: "Error loading prior settings/events " + (e && e.toString())
      });
    }
  };
  FloodgateEngine.prototype.getAvailableChannelTypes = function () {
    // Make sure we've loaded the current survey definitions
    var channels = this.governor.getAvailableChannelData();
    var channelTypes = [];
    channels.forEach(function (channel) {
      if (channel) {
        channelTypes.push(channel.getType());
      }
    });
    return channelTypes;
  };
  FloodgateEngine.prototype.setPendingSurveysAndStartFloodgate = function () {
    // Update our survey list, and push that through to the listener
    this.setPendingSurveys(this.surveyClient.getAppSurveys());
    this.updateActivityListenerWithCurrentSurveyDefinitions();
    // Mark us as started
    this.setInitializationStatus(3 /* Started */);
    // Log our first start (aka floodgate boot) event
    if (!this.loggedFirstStart) {
      this.loggedFirstStart = true;
      this.getActivityListener().logActivity(SurveyActivityListener.FloodgateStartActivityName);
    }
  };
  FloodgateEngine.prototype.updateSurveyActivationStats = function (survey) {
    var surveyInfo = survey.getSurveyInfo();
    var surveyId = surveyInfo.getId();
    var stats = this.previousSurveyActivationStats.getStats()[surveyId] || new SurveyStatCollectionActivation_1.SurveyActivationStats();
    stats.Type = survey.getType();
    stats.ExpirationTimeUtc = surveyInfo.getExpirationTimeUtc();
    stats.ActivationTimeUtc = new Date();
    stats.SurveyLaunchCount++;
    stats.SurveyLaunchCountPerSession++;
    this.previousSurveyActivationStats.addStats(surveyId, stats);
  };
  FloodgateEngine.prototype.saveSurveyActivationHistory = function () {
    this.storage.fileLock(FileType.SurveyActivationStats);
    try {
      var statCollection = this.surveyActivationStatsProvider.load();
      var previousStats = this.previousSurveyActivationStats.getStats();
      // Build the update collection
      var updateCollection = new SurveyStatCollectionActivation_1.SurveyStatCollectionActivation();
      for (var key in this.launchedSurveys) {
        if (this.launchedSurveys.hasOwnProperty(key)) {
          var survey = this.launchedSurveys[key];
          var surveyId = survey.getSurveyInfo().getId();
          // Make this part of the update list
          var stats = previousStats[surveyId];
          updateCollection.addStats(surveyId, stats);
        }
      }
      // Actually merge our updates into the full collection
      statCollection.accumulate(updateCollection);
      this.surveyActivationStatsProvider.save(statCollection);
      // Make sure to keep our internal collection consistent with what we just wrote
      this.previousSurveyActivationStats = statCollection;
    } finally {
      this.storage.fileUnlock(FileType.SurveyActivationStats);
    }
  };
  FloodgateEngine.prototype.saveSurveyEventActivityHistory = function () {
    this.storage.fileLock(FileType.SurveyEventActivityStats);
    try {
      var statCollection = SurveyStatCollectionEventActivity_1.SurveyStatCollectionEventActivity.fromJson(this.readString(FileType.SurveyEventActivityStats));
      var now = new Date();
      // Fill out our list of updates
      var updateCollection = new SurveyStatCollectionEventActivity_1.SurveyStatCollectionEventActivity();
      var _loop_1 = function (key) {
        if (this_1.candidateSurveys.hasOwnProperty(key)) {
          var stats = new SurveyStatCollectionEventActivity_1.SurveyEventActivityStats();
          var survey = this_1.candidateSurveys[key];
          if (!survey.getSurveyInfo().isActiveForDate(now)) {
            return "continue";
          }
          stats.ExpirationTimeUtc = survey.getSurveyInfo().getExpirationTimeUtc();
          // Get the activities which are aggregated, if there aren't any continue
          var allActivities = survey.getSurveyInfo().getActivationEvent().getTrackingSet();
          var aggregateActivities_1 = [];
          var nonAggregateActivities_2 = [];
          allActivities.getList().forEach(function (data) {
            if (data) {
              if (data.getIsAggregate()) {
                aggregateActivities_1.push(data.getActivity());
              } else {
                nonAggregateActivities_2.push(data.getActivity());
              }
            }
          });
          stats.Counts = new Array(aggregateActivities_1.length);
          // Save off the counts we've added for this session
          for (var i = 0; i < aggregateActivities_1.length; i++) {
            stats.Counts[i] = this_1.activityListener.moveSessionCountIntoBaseCount(aggregateActivities_1[i], survey.getSurveyInfo().getId());
          }
          for (var _i = 0, nonAggregateActivities_1 = nonAggregateActivities_2; _i < nonAggregateActivities_1.length; _i++) {
            var activity = nonAggregateActivities_1[_i];
            this_1.activityListener.saveSessionTrackingActivity(activity);
          }
          // Make this part of the update list
          updateCollection.addStats(survey.getSurveyInfo().getId(), stats);
        }
      };
      var this_1 = this;
      for (var key in this.candidateSurveys) {
        _loop_1(key);
      }
      // Actually merge our updates into the full collection
      statCollection.accumulate(updateCollection);
      this.writeString(FileType.SurveyEventActivityStats, SurveyStatCollectionEventActivity_1.SurveyStatCollectionEventActivity.toJson(statCollection));
      // Make sure to keep our internal collection consistent with what we just wrote
      this.previousSurveyEventActivityStats = statCollection;
    } finally {
      this.storage.fileUnlock(FileType.SurveyEventActivityStats);
    }
  };
  FloodgateEngine.prototype.setPendingSurveys = function (pendingSurveys) {
    this.candidateSurveys = {};
    if (pendingSurveys) {
      for (var key in pendingSurveys) {
        if (pendingSurveys.hasOwnProperty(key)) {
          var survey = pendingSurveys[key];
          if (this.launcherFactory.AcceptsSurvey(survey)) {
            this.candidateSurveys[key] = survey;
          }
        }
      }
    }
  };
  FloodgateEngine.prototype.getCurrentSurveyDefinitions = function () {
    var _this = this;
    // Get a vector of Surveys from our id-based map
    var surveyList = new Array();
    var allCampaignDefinitionIDs = this.getAllCampaignDefinitionIDs();
    var allCandidateCampaignDefinitionIDs = this.getAllCandidateCampaignDefinitionIDs();
    // Get all the campaign definitions. We need info from these for telemetry.
    var allCampaignDefinitions = this.surveyClient.getCampaignDefinitions();
    var isSurveyAllowed = function (surveyInfo) {
      // always allow business critical and approved campaigns
      if (GovernanceUtils_1.isBusinessCriticalSurvey(surveyInfo)) {
        return true;
      }
      var surveyActivationStats = _this.previousSurveyActivationStats.getBySurveyId(surveyInfo.getId());
      if (GovernanceUtils_1.isMultiLaunchSurvey(surveyInfo) && !GovernanceUtils_1.hasSurveyReachedMaxLaunches(surveyInfo, surveyActivationStats) && !GovernanceUtils_1.hasSurveyReachedMaxLaunchesPerSession(surveyInfo, surveyActivationStats)) {
        return true;
      }
      // Skip over any candidate surveys that have been previously completed or not active anymore
      if (surveyActivationStats || !surveyInfo.isActiveForDate(new Date())) {
        return false;
      }
      return true;
    };
    for (var key in this.candidateSurveys) {
      if (this.candidateSurveys.hasOwnProperty(key)) {
        var survey = this.candidateSurveys[key];
        var surveyInfo = survey.getSurveyInfo();
        var campaignDefinition = allCampaignDefinitions[surveyInfo === null || surveyInfo === void 0 ? void 0 : surveyInfo.getBackEndId()];
        if (!campaignDefinition || !isSurveyAllowed(surveyInfo)) {
          continue;
        }
        // send the UserSelected event if it is not sent before
        if (this.surveyEventSent.indexOf(key) < 0) {
          this.surveyEventSent.push(key);
          var additionalSurveyInfo = this.getAdditionalSurveyInfoForTelemetry(survey, allCampaignDefinitionIDs, allCandidateCampaignDefinitionIDs);
          FloodgateEngine.telemetryLogger.log_UserSelected(surveyInfo.getBackEndId(), surveyInfo.getId(), survey.getType(), JSON.stringify(additionalSurveyInfo));
        }
        surveyList.push(survey);
      }
    }
    return surveyList;
  };
  FloodgateEngine.prototype.getAdditionalSurveyInfoForTelemetry = function (survey, allCampaignDefinitionIDs, allCandidateCampaignDefinitionIDs) {
    // Get all the campaign definitions. We need info from these for telemetry.
    var allCampaignDefinitions = this.surveyClient.getCampaignDefinitions();
    // Get the corresponding campaign definition to the survey in question.
    var correspondingCampaignDefinition = allCampaignDefinitions[survey.getCampaignId()];
    // Survey properties to get from its corresponding CampaignDefinition:
    var percentageNumerator;
    var percentageDenominator;
    var nominationPeriodNumber;
    var cooldownPeriodNumber;
    percentageNumerator = correspondingCampaignDefinition.nominationScheme.percentageNumerator;
    percentageDenominator = correspondingCampaignDefinition.nominationScheme.percentageDenominator;
    nominationPeriodNumber = correspondingCampaignDefinition.nominationScheme.nominationPeriod.asTimeIntervalSeconds();
    nominationPeriodNumber = Utils_1.isNOU(nominationPeriodNumber) ? -1 : nominationPeriodNumber; // Setting to -1 if null or undefined
    cooldownPeriodNumber = correspondingCampaignDefinition.nominationScheme.cooldownPeriod.asTimeIntervalSeconds();
    cooldownPeriodNumber = Utils_1.isNOU(cooldownPeriodNumber) ? -1 : cooldownPeriodNumber; // Setting to -1 if null or undefined
    var surveyInfo = survey.getSurveyInfo();
    return {
      allCampaignDefinitionIDs: allCampaignDefinitionIDs,
      allCandidateCampaignDefinitionIDs: allCandidateCampaignDefinitionIDs,
      channelType: surveyInfo.getGovernedChannelType(),
      cooldownPeriodNumber: cooldownPeriodNumber,
      nominationPeriodNumber: nominationPeriodNumber,
      percentageDenominator: percentageDenominator,
      percentageNumerator: percentageNumerator,
      surveyLauncherType: survey.getLauncherType(),
      businessLevel: surveyInfo.getBusinessLevel(),
      maxLaunches: surveyInfo.getMaxLaunches(),
      maxLaunchesPerSession: surveyInfo.getMaxLaunchesPerSession()
    };
  };
  FloodgateEngine.prototype.getAllCandidateCampaignDefinitionIDs = function () {
    var allCandidateCampaignDefinitionIDs = [];
    // Get all the candidate surveys' campaign definition IDs
    for (var key in this.candidateSurveys) {
      if (this.candidateSurveys.hasOwnProperty(key)) {
        var candidateSurvey = this.candidateSurveys[key];
        allCandidateCampaignDefinitionIDs.push(candidateSurvey.getSurveyInfo().getBackEndId());
      }
    }
    return allCandidateCampaignDefinitionIDs;
  };
  FloodgateEngine.prototype.getAllCampaignDefinitionIDs = function () {
    var allCampaignDefinitions = this.surveyClient.getCampaignDefinitions();
    var allCampaignDefinitionIDs = [];
    for (var definitionsKey in allCampaignDefinitions) {
      if (Object.prototype.hasOwnProperty.call(allCampaignDefinitions, definitionsKey)) {
        var definition = allCampaignDefinitions[definitionsKey];
        allCampaignDefinitionIDs.push(definition.campaignId);
      }
    }
    return allCampaignDefinitionIDs;
  };
  FloodgateEngine.prototype.updateActivityListenerWithCurrentSurveyDefinitions = function () {
    var surveyList = this.getCurrentSurveyDefinitions();
    var trackingContractList = [];
    for (var _i = 0, surveyList_1 = surveyList; _i < surveyList_1.length; _i++) {
      var survey = surveyList_1[_i];
      var surveyInfo = survey.getSurveyInfo();
      var trackingContract = new ActivityTrackingContract_1.ActivityTrackingContract(surveyInfo.getId(), surveyInfo.getActivationEvent().getTrackingSet());
      trackingContractList.push(trackingContract);
    }
    this.activityListener.SetActivityTrackingContracts(trackingContractList, this.previousSurveyEventActivityStats);
  };
  FloodgateEngine.prototype.setCriticalPendingSurveysAndUpdateActivityListener = function () {
    var activeSurveys = {};
    // Get all the candidate surveys' campaign definition IDs
    for (var key in this.candidateSurveys) {
      if (this.candidateSurveys.hasOwnProperty(key)) {
        var candidateSurvey = this.candidateSurveys[key];
        if (GovernanceUtils_1.isCriticalSurvey(candidateSurvey.getSurveyInfo())) {
          activeSurveys[key] = candidateSurvey;
        }
      }
    }
    if (Object.keys(activeSurveys).length > 0) {
      this.setPendingSurveys(activeSurveys);
      this.updateActivityListenerWithCurrentSurveyDefinitions();
    }
  };
  FloodgateEngine.prototype.shouldAcceptActivity = function (activityName) {
    return this.initializationStatus === 3 /* Started */ || activityName === SurveyActivityListener.FloodgateStartActivityName;
  };
  FloodgateEngine.prototype.onSurveyActivated = function (surveyId) {
    // Find the survey object that corresponds to the surveyId passed
    var surveys = this.getCurrentSurveyDefinitions();
    var survey;
    for (var _i = 0, surveys_1 = surveys; _i < surveys_1.length; _i++) {
      var tempSurvey = surveys_1[_i];
      if (tempSurvey.getSurveyInfo().getId() === surveyId) {
        survey = tempSurvey;
        break;
      }
    }
    if (Utils_1.isNOU(survey)) {
      FloodgateEngine.getTelemetryLogger().log_Error(Constants_1.TelemetryEvent.FloodgateEngine.OnSurveyActivated.SurveyNotDefined, "Survey is not defined in the current survey definitions.");
      return;
    }
    // Get the stringified json with activity names, counts and isAggregate info for TriggetMet telemetry.
    var activityTrackingString = survey.getSurveyInfo().getActivationEvent().getTrackingSet().getActivityTrackingInfo(this.activityListener, surveyId);
    var additionalSurveyInfo = this.getAdditionalSurveyInfoForTelemetry(survey, this.getAllCampaignDefinitionIDs(), this.getAllCandidateCampaignDefinitionIDs());
    // Only adding the governance service client state at TriggerMet event
    additionalSurveyInfo.governanceServiceClientState = this.governanceServiceClient.getClientState();
    FloodgateEngine.telemetryLogger.log_TriggerMet(survey.getSurveyInfo().getBackEndId(), survey.getSurveyInfo().getId(), survey.getType(), activityTrackingString, JSON.stringify(additionalSurveyInfo));
    try {
      var governedChannelType = survey.getSurveyInfo().getGovernedChannelType();
      // If the governance service is in use, launch survey asynchronously
      if (this.governanceServiceClient.isEnabled(governedChannelType)) {
        // record the stale surveys, so we can clear its tracker if Engine is stopped
        this.staleTriggeredSurveysQueue.push(survey);
        // If there is no survey in stale before, launch the survey right away
        if (this.staleTriggeredSurveysQueue.length === 1) {
          // Launch the survey asynchronously
          this.checkGovernanceServiceAndActivateSurvey(survey, governedChannelType);
        }
      } else {
        this.activateSurvey(survey, governedChannelType);
      }
    } catch (e) {
      FloodgateEngine.telemetryLogger.log_Event(Constants_1.TelemetryEvent.FloodgateEngine.OnSurveyActivated.Error, {
        ErrorMessage: "Error activating survey " + (e && e.toString()),
        ErrorDetails: e && e.stack
      });
    }
  };
  FloodgateEngine.prototype.activateSurvey = function (survey, governedChannelType) {
    var launchSurvey = false;
    // Figure out if the activated survey is still relevant
    if (!this.candidateSurveys[survey.getSurveyInfo().getId()]) {
      // Survey is no longer relevant but was activated. Suppress it.
    } else if (!survey.getSurveyInfo().isActiveForDate(new Date())) {
      // Survey is no longer active (e.g. it was when we registered it but it has now expired)
    } else {
      // Refresh channels
      this.governor.refreshChannelData();
      if (GovernanceUtils_1.isCriticalSurvey(survey.getSurveyInfo())) {
        launchSurvey = true;
      } else if (!this.governor.isChannelOpen(governedChannelType)) {
        // Channel has closed and maxLaunches is not set, suppress the survey
        FloodgateEngine.getTelemetryLogger().log_Event(Constants_1.TelemetryEvent.FloodgateEngine.OnSurveyActivated.ClosedChannelType, {
          ClosedChannelType: GovernedChannel_1.GovernedChannelType[governedChannelType]
        });
      } else {
        // Get latest survey states from provider
        var refreshedSurveyActivationStats = this.surveyActivationStatsProvider.load();
        if (refreshedSurveyActivationStats.getBySurveyId(survey.getSurveyInfo().getId())) {
          // Survey stats exists already, don't launch
          FloodgateEngine.getTelemetryLogger().log_Event(Constants_1.TelemetryEvent.FloodgateEngine.OnSurveyActivated.ActivationStatsSuppressedSurvey, {
            CampaignId: survey.getSurveyInfo().getBackEndId(),
            SurveyId: survey.getSurveyInfo().getId()
          });
        } else if (Object.keys(this.launchedSurveys).length === 0) {
          // for now we only support launching one survey per session unless it is multi-launch campaign
          // Track this survey activation for the launch history tracker
          launchSurvey = true;
        } else {
          var triggeredSurvey = Object.values(this.launchedSurveys)[0];
          if (!Utils_1.isNOU(triggeredSurvey)) {
            FloodgateEngine.getTelemetryLogger().log_Event(Constants_1.TelemetryEvent.FloodgateEngine.OnSurveyActivated.SessionSuppressedSurvey, {
              CampaignId: triggeredSurvey.getSurveyInfo().getBackEndId(),
              SurveyId: triggeredSurvey.getSurveyInfo().getId()
            });
          }
        }
      }
      if (launchSurvey) {
        this.launchedSurveys[survey.getSurveyInfo().getId()] = survey;
      }
    }
    // At this point, regardless of whether or not the survey is still relevant, we should flush out the stats
    this.updateSurveyActivationStats(survey);
    this.mergeAndSave();
    // shut off further survey launches
    this.activityListener.clearSurveys();
    // Clear the survey from stale list
    this.staleTriggeredSurveysQueue = [];
    // Actually launch the survey if possible
    if (launchSurvey) {
      // Set govern channel
      this.governor.startChannelCooldown(governedChannelType);
      var surveyInfo = survey.getSurveyInfo();
      var isSurveyComplete = true;
      if (GovernanceUtils_1.isBusinessCriticalSurvey(surveyInfo)) {
        // critical campaigns are not tracked
        isSurveyComplete = false;
      } else if (GovernanceUtils_1.isMultiLaunchSurvey(surveyInfo)) {
        var surveyActivationStats = this.previousSurveyActivationStats.getBySurveyId(surveyInfo.getId());
        isSurveyComplete = GovernanceUtils_1.hasSurveyReachedMaxLaunches(surveyInfo, surveyActivationStats);
      }
      // Set campaign states
      this.surveyClient.onSurveyActivated(surveyInfo, isSurveyComplete);
      // Show the survey
      this.launchLauncher(survey);
      // check if there are any critical campaigns and start tracking again
      this.setCriticalPendingSurveysAndUpdateActivityListener();
    }
  };
  FloodgateEngine.prototype.checkGovernanceServiceAndActivateSurvey = function (survey, governedChannelType) {
    return __awaiter(this, void 0, void 0, function () {
      var campaignDefinition, campaignCooldown, channelCooldown, serviceResult, launchSurvey, lastSurveyTriggerInfo;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            campaignDefinition = this.surveyClient.getCampaignDefinitions()[survey.getCampaignId()];
            campaignCooldown = campaignDefinition.nominationScheme.cooldownPeriod.asTimeIntervalSeconds();
            channelCooldown = Governor_1.Governor.GetChannelCoolDown(governedChannelType);
            return [4 /*yield*/, this.governanceServiceClient.checkGovernancePermitAsync(survey, campaignCooldown, channelCooldown, governedChannelType)];
          case 1:
            serviceResult = _a.sent();
            launchSurvey = false;
            // Log the stale
            FloodgateEngine.getTelemetryLogger().log_Event(Constants_1.TelemetryEvent.FloodgateEngine.CheckGovernanceServiceAndActivateSurvey.GovernanceServiceClientCompleted, {
              Message: JSON.stringify(this.createGorvernanceResponseTelemetry(serviceResult))
            });
            // Check if engine is still running
            if (this.initializationStatus !== 3 /* Started */) {
              return [2 /*return*/];
            }
            if (!serviceResult.error) {
              // Check result is permitted
              if (serviceResult.permission) {
                // the Governance Service is permitting, continue to trigger
                launchSurvey = true;
              } else {
                lastSurveyTriggerInfo = serviceResult.lastTriggerSurvey;
                // For now, we only know the channel is in cooldown but not the specific survey
                // So only set governed channel to new cooldown
                this.governor.startChannelCooldown(governedChannelType, lastSurveyTriggerInfo.lastTriggerSurveyTime);
                // Clear the survey relating to channel
                this.clearSurveyWithChannel(governedChannelType);
              }
            } else {
              // If force to display with error, continue to trigger the survey
              if (this.governanceServiceClient.shouldForceDisplay()) {
                launchSurvey = true;
                // Log the force to display event
                FloodgateEngine.getTelemetryLogger().log_Event(Constants_1.TelemetryEvent.FloodgateEngine.CheckGovernanceServiceAndActivateSurvey.GovernanceServiceForceToDisplay, {
                  ErrorMessage: serviceResult.errorMessage
                });
              }
            }
            if (launchSurvey) {
              // Launch the survey
              this.activateSurvey(survey, governedChannelType);
              return [2 /*return*/];
            }
            // If there is only one survey, which is the current one in process, clear queue and return
            if (this.staleTriggeredSurveysQueue.length <= 1) {
              this.staleTriggeredSurveysQueue = [];
              return [2 /*return*/];
            }
            // Remove the first activated survey from the list which is the current one in process
            this.staleTriggeredSurveysQueue.shift();
            // Playback the next activated survey in waiting
            this.checkGovernanceServiceAndActivateSurvey(this.staleTriggeredSurveysQueue[0], governedChannelType);
            return [2 /*return*/];
        }
      });
    });
  };
  FloodgateEngine.prototype.readString = function (fileType) {
    return this.storage.read(fileType);
  };
  FloodgateEngine.prototype.writeString = function (fileType, str) {
    this.storage.write(fileType, str);
  };
  FloodgateEngine.prototype.launchLauncher = function (survey) {
    var launcher = this.launcherFactory.makeSurveyLauncher(survey);
    if (launcher) {
      this.launchedLaunchers.push(launcher);
      this.onSurveyActivatedCallback.onSurveyActivated(launcher, survey);
    }
  };
  FloodgateEngine.prototype.clearSurveyWithChannel = function (governedChannelType) {
    var activeSurveys = {};
    // Get all the candidate surveys' campaign definition IDs
    for (var key in this.candidateSurveys) {
      if (this.candidateSurveys.hasOwnProperty(key)) {
        var candidateSurvey = this.candidateSurveys[key];
        if (candidateSurvey.getSurveyInfo().getGovernedChannelType() !== governedChannelType) {
          activeSurveys[key] = candidateSurvey;
        }
      }
    }
    this.candidateSurveys = activeSurveys;
    this.activityListener.UpdateActivityTrackingContracts(this.candidateSurveys);
  };
  FloodgateEngine.prototype.createGorvernanceResponseTelemetry = function (serviceResult) {
    return {
      FloodgateEngineStatus: this.initializationStatus.toString(),
      GovernanceServiceResult: serviceResult,
      StaleTriggeredSurveysQueueCount: this.staleTriggeredSurveysQueue.length - 1
    };
  };
  // Initialize telemetry logger with no-op logger
  FloodgateEngine.telemetryLogger = new DefaultFloodgateTelemetryLogger();
  return FloodgateEngine;
}();
exports.FloodgateEngine = FloodgateEngine;